import { useEffect } from "react";
import { Toast, useToast } from "../utils";

export default function QueuedToastListener() {
  const { showToast, toastMessage, hideToast } = useToast(4000);

  useEffect(() => {
    const onQueued = () => {
      showToast("Connection interrupted. This change is pending and will retry automatically.", "warning");
    };
    const onChartSaved = () => showToast("Saved on device. Not yet synced to the server.", "warning");
    const onDeviceSaveFailed = (event) => showToast(
      event.detail?.message || "Not saved on device. Keep this chart open and reconnect before leaving.",
      "error"
    );
    window.addEventListener("vela:write-queued", onQueued);
    window.addEventListener("vela:chart-saved-on-device", onChartSaved);
    window.addEventListener("vela:chart-device-save-failed", onDeviceSaveFailed);
    return () => {
      window.removeEventListener("vela:write-queued", onQueued);
      window.removeEventListener("vela:chart-saved-on-device", onChartSaved);
      window.removeEventListener("vela:chart-device-save-failed", onDeviceSaveFailed);
    };
  }, [showToast]);

  if (!toastMessage) return null;
  return <Toast message={toastMessage} onClose={hideToast} />;
}
